import React, { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import ErrorComponent from "../../../Components/ErrorMessage";
import "./image.css";
import { replacePlaceholder } from "../../../Utils/Utils";
function ImagePicker({ question, handleChange, formValues, showError }) {
  const currentValue = formValues[question.tempId];
  const hasAnswer = currentValue !== undefined && currentValue !== null;
  const isMandatory = question.isMandatory;
  const questionText = replacePlaceholder(question.questionText, formValues);

  const [sortedChoices, setSortedChoices] = React.useState([]);
  const initializedRef = React.useRef(false);

  /* ---------- RANDOMIZE ONCE ---------- */
  const shuffleArray = (array) => {
    const arr = [...array];
    for (let i = arr.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [arr[i], arr[j]] = [arr[j], arr[i]];
    }
    return arr;
  };

  useEffect(() => {
    if (initializedRef.current) return;
    initializedRef.current = true;

    let choices = [...question.choices];

    if (question.choicesOrder === "random") {
      choices = shuffleArray(choices);
    } else if (question.choicesOrder === "ascending") {
      choices.sort((a, b) => a.value.localeCompare(b.value));
    } else if (question.choicesOrder === "descending") {
      choices.sort((a, b) => b.value.localeCompare(a.value));
    }

    setSortedChoices(choices);
  }, [question]);

  /* ---------- SELECTION (UNCHANGED) ---------- */
  const handleSelectImage = (choice) => {
    const newValue = currentValue === choice.value ? null : choice.value;
    handleChange({
      target: { name: question.tempId, value: newValue },
    });
  };

  const isImageSelected = (choice) => currentValue === choice.value;

  return (
    <Card
      className={`mt-3 ${isMandatory && showError && !hasAnswer ? "border-danger" : ""}`}
      style={{ width: "100%" }}
    >
      <Card.Body>
        <div className="d-flex flex-column">
          <b style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
            <label htmlFor={question.tempId}>
              {question.tempId}.{questionText}
              {isMandatory && <span className="text-danger">*</span>}
            </label>
          </b>
          <b style={{ color: "lightblue" }}>
            {question.questionDescription}
          </b>
          {isMandatory && showError && !hasAnswer && (
            <ErrorComponent message={question.requiredErrorText} />
          )}
        </div>

        <div className="d-flex flex-wrap mt-3">
          {sortedChoices.map((choice) => (
            <div
              key={choice.value}
              className={`image-container ${
                isImageSelected(choice) ? "selected" : ""
              }`}
            >
              <img
                src={choice.imageLink}
                alt={choice.value}
                className="image"
                style={{ width: "200px", height: "200px" }}
                onClick={() => handleSelectImage(choice)}
              />
              {isImageSelected(choice) && (
                <div className="selected-overlay right">
                  <i className="fas fa-check"></i>
                </div>
              )}
            </div>
          ))}
        </div>
      </Card.Body>
    </Card>
  );
}


export default ImagePicker;
